import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  changeModalVisibility,
  setNutritionistsList,
  setNutritionistDataToEdit,
  setNutritionistsCount,
} from '../../store/nutritionistsSlice';
import './NutritionistPage.scss';
import Button from '../../components/BaseComponents/Button';
import { getNutritionistsList } from '../../api/nutritionist';
import {  getNutritionistsCount } from '../../api/counters';
import Loader from '../../components/BaseComponents/Loader';
import { UserRoleEnum } from '../../types/apiGeneratedTypes';
import { useNavigate } from 'react-router';
import NutritionistTable from '../../components/Nutritionist/NutritionistTable';
import NutritionistModal from '../../components/Nutritionist/NutritionistModal';

const Nutritionist: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<any>(null);
  const { nutritionistsCount, isAddNutritionistModalOpened, limit, sortKey, sortOrder } = useSelector(
    (state: RootState) => state.nutritionists
  );
  const {
    admin: { role },
  } = useSelector((state: RootState) => state.admin);
  const nutritionistsCountRef = useRef(nutritionistsCount);
  nutritionistsCountRef.current = nutritionistsCount;

  useEffect(() => {
    if (role === UserRoleEnum.Nutritionist) {
      navigate('/members');
    }
  }, [role, navigate]);

  useEffect(() => {
    const fetchNutritionists = async () => {
      try {
        setLoading(true);
        console.log('Fetching nutritionists with sort params:', { sortKey, sortOrder });
        
        const nutritionistsList = await getNutritionistsList(
          0, 
          limit, 
          undefined, 
          sortKey === 'name' ? 'name' : sortKey === 'email' ? 'email' : undefined,
          sortOrder
        );
        
        console.log('Nutritionists fetched:', nutritionistsList);
        dispatch(setNutritionistsList(nutritionistsList.nutritionists));
        if (!nutritionistsCountRef.current) {
          const nutritionistsCountResp = await getNutritionistsCount();
          dispatch(setNutritionistsCount(nutritionistsCountResp.total_count));
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchNutritionists();
  }, [sortKey, sortOrder, dispatch, limit]);

  const onAddClinicBtnClick = () => {
    dispatch(setNutritionistDataToEdit(null));
    dispatch(changeModalVisibility(true));
  };
  const onModalClose = () => {
    dispatch(changeModalVisibility(false));
  };

  if (loading) return <Loader />;
  if (error) return <div>Error loading nutritionists list...</div>;

  return (
    <div className='page-container'>
      <div className='search-row-container sideBarPad'>
        <div className='search-and-filter-container'>
          <div className='count-container'>
            Nutritionist ({nutritionistsCount})
          </div>
        </div>
        <Button
          isSecondary={true}
          text='Add Nutritionist'
          onClick={onAddClinicBtnClick}
        />
      </div>

      <NutritionistTable key={nutritionistsCount} />
      <NutritionistModal isOpen={isAddNutritionistModalOpened} onClose={onModalClose} />
    </div>
  );
};
export default Nutritionist;
